import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { AuthService } from '../services/auth.service';
import { WhiteLabelService } from '../services/white-label.service';
import { Constants } from '../shared/constants/constants';

@Injectable()
export class IsAuthenticated implements CanActivate {
  constructor(
    public afAuth: AngularFireAuth,
    private toastr: ToastrService,
    public constants: Constants,
    private authService: AuthService,
    private whiteLabelService: WhiteLabelService,
    private router: Router,
    private translate: TranslateService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return new Observable(observer => {
      this.afAuth.authState.subscribe((auth) => {
        if (isNullOrUndefined(auth)) {
          this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
          observer.next(false);
          observer.complete();
          return;
        }

        const user = this.authService.getUser();
        if (user && user.buildings && user.buildings.length > 0) {
          const buildings = user.buildings;
          this.whiteLabelService.setSessionLoginPathFromBuilding(buildings[0]);

          if (buildings[0].status !== this.constants.ACTIVE_STATUS && !user.superUser) {
            this.authService.doLogoutAsync();
            this.toastr.error(this.translate.instant('toastrMessage.error.userInactive'));
            this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
            observer.next(false);
            observer.complete();
            return;
          }

          if (buildings[0].userStatus !== this.constants.ACTIVE_STATUS && !user.superUser) {
            this.authService.doLogoutAsync();
            this.toastr.error(this.translate.instant('toastrMessage.error.userInactive'));
            this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
            observer.next(false);
            observer.complete();
            return;
          }

          observer.next(true);
          observer.complete();
        } else {
          observer.next(true);
          observer.complete();
        }
      });
    });
  }
}
